export const first = <T>(arr: T[]): T => arr[0];
